import { Role } from '../enums/Role';

export const checkRoleAccess = (allowedRoles: Role[], userRoles: Role[]) => {
    return userRoles.some(r => allowedRoles.includes(r))
}
